import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./ui/tokens.css";
import "./ui/estilos.css";

/**
 * Sin service worker y sin nada instalable, al contrario que el producto
 * (`ADR-0004`): un backoffice cacheado en el dispositivo de alguien es
 * exactamente lo que no se quiere.
 */
const raiz = document.getElementById("raiz");
if (raiz === null) throw new Error("Falta el elemento #raiz en index.html.");

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
